// Controls overlaid on the media — a click on one of these isn't a click on
// the media itself.
const CONTROLS = "[data-video-control-button], .lifestyle-media__shop-the-look";

/**
 * Opens the zoom modal on a piece of lifestyle media, by pressing the zoom
 * trigger that sits over it so every open runs through the one handler below.
 *
 * @param media {Element} `[data-media]` wrapper holding the clicked media
 * @param target {Element} What the click landed on
 */
export function openZoom(media, target) {
  if (!media || target.closest(CONTROLS)) return;

  media.querySelector("[data-open-zoom]")?.click();
}

/**
 * Lifestyle imagery in the PDP additional content column.
 *
 * Its only behaviour is opening the zoom modal on the media that was clicked.
 * The modal's markup lives inside `media-gallery`, so the open is asked for by
 * event rather than performed here.
 *
 * Carousel slides don't take their clicks from here: `lifestyle-carousel` picks
 * them up off Swiper's own click event, which doesn't fire for the press that
 * ends a drag.
 */
class LifestyleMedia extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", (e) => {
      const trigger = e.target.closest("[data-open-zoom]");

      if (trigger) {
        trigger.dispatchEvent(
          new CustomEvent("zoom-gallery:open", {
            bubbles: true,
            detail: { view: "carousel", mediaId: trigger.dataset.mediaId },
          }),
        );
        return;
      }

      if (e.target.closest("lifestyle-carousel")) return;

      openZoom(e.target.closest("[data-media]"), e.target);
    });
  }
}

if (!customElements.get("lifestyle-media")) {
  customElements.define("lifestyle-media", LifestyleMedia);
}
